import { cn } from '@/lib/utils';

export function Spinner({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'h-5 w-5 rounded-full border-2 border-[var(--border)] border-t-[var(--accent)]',
        className,
      )}
      style={{ animation: 'spin 0.8s linear infinite' }}
      role="status"
      aria-label="Loading"
    />
  );
}
